<style scoped>
    @import url("../../styles/smartControl/phaseSC.scss");
</style>

<template>
    <div class="box_phaseSC">

        <!-- MAIN TIT -->
        <div class="titGeral">
            <v-icon :style="{'color':'rgb(31,122,177)'}">mdi-timeline-text-outline</v-icon>
            <span class="ml-2">Produção por fase</span>
        </div>

        <span v-if="flagOpenMsgErro">{{ msgErro }}</span>

        <!-- Caixa de diálogo aberta após input de atualização -->
        <v-dialog v-model="flagDialog" max-width="250px">
            <div v-if="!flagLoading && flagDialog">
                <DialogMsg 
                v-if="flagDialog" 
                :msgFromFather="msg2child"
                @fromDialogMsg="flagDialog = false"
                />
            </div>
        </v-dialog>

        <!-- LOADING após search btn -->
        <div v-if="flagLoading" class="mb-16 mt-16"
        :style="{'display':'flex','width':'100%','align-items':'center','justify-content':'center'}">
            <v-progress-circular 
                color="black"
                size="64"
                indeterminate
            ></v-progress-circular>
        </div>

        <div class="hidden-md-and-up">Desabilitado</div>

        <!-- operações específicas do componente -->
        <div class="painelGeral hidden-sm-and-down" v-if="!flagLoading && !flagOpenMsgErro">

            <!-- criar nova fase de produção -->
            <CriarFase v-if="!flagExibPhase"
            />

            <!-- todas as fases existentes -->
            <ExibFases v-if="!flagExibPhase"
            :agent_unit="agent_unit" 
            @idPhaseSelected="openPhaseById($event)" 
            />

            <!-- fase escolhida pelo index list -->
            <FaseExib v-if="flagExibPhase"
            :agent_unit="agent_unit" 
            :idPhase="idPhaseFromSelect" 
            @flagBoolClosePhase="flagExibPhase = $event"

            @msg2Dialog="msg2child = $event"
            @openDialog="resetExib()"
            />

        </div>

    </div>
</template>

<script>
import axios from 'axios'

import DialogMsg from './subFaseProd/DialogMsg'

import CriarFase from './subFaseProd/CriarFase'
import ExibFases from './subFaseProd/ExibFases'
import FaseExib from './subFaseProd/FaseExib'

export default {

    components:{
        DialogMsg, 
        CriarFase,
        ExibFases,
        FaseExib
    },

    data() {
        return {
            
            // -- sistema SC.
            flagMsgSistema:false, // sistema geral precisa estar definido para req init.
            msgSistema:'Selecione um sistema na página "Início"',

            // -- controle da atual página.
            flagLoading:false, // init true loading em produção
            flagDialog:false, // abrir e fechar dialog de confirmação após input
            msg2child:'', // msg no dialog final

            // -- op
            agent_unit:{},
            idPhaseFromSelect:null,
            flagExibPhase:false,

            // - erro
            flagOpenMsgErro:false,
            msgErro:'',
        }
    },

    methods:{

        openPhaseById(indexFromChild) {
            console.log('indexFromChild: ',indexFromChild)
            this.idPhaseFromSelect = indexFromChild
            this.flagExibPhase = true
        },

        changeFlagLoading(flagLoadingFromChild) {
            console.log('flagLoadingFromChild: ',flagLoadingFromChild)
            this.flagLoading = flagLoadingFromChild
        },

        resetExib() {
            this.flagDialog = true
            this.initInfo()
        },

        async initInfo() {
            this.flagLoading = true // -- open loading

            this.sistema = this.$store.state.sistemaSC
            let cl = this.$store.state.emailCliente

            const headers = {
                'Authorization': `Bearer ${this.$store.state.tox}`,
                'Content-Type': 'application/json'
            }

            let self = this

            let params = {'cliente':cl, 'sistema':this.sistema}

            const res = await axios.post(self.$store.state.pathAxiosAgentIA, params, {headers})

            //console.log(res.data.result) // agent 
            this.agent_unit = res.data.result // agent_unit

            // -- verificar se existe a key de irrig antes de abrir.
            const flagE = Object.hasOwn(this.agent_unit, 'phases')
            if (!flagE) { 
                this.flagOpenMsgErro = true
                this.msgErro = 'Produção faseada desabilitada' 
            }

            this.flagLoading = false
        },
    },

    created() {
        window.scrollTo(0,0)

        // -- obter sistema atual selecionado.
        let execSys = this.$store.state.sistemaSC

        // -- se sistema vazio, então não buscar o sistema...
        if (execSys == '') { this.flagMsgSistema = true; return; } 
        else { this.initInfo() }
    }
}
</script>